import { useContext } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { Context } from './context';
import { HEADERS } from 'views/reports/fileReport/constants';
import { dateFormater } from 'utils/dateTimeHelper';
import {
  fetchAllDownloads,
  buildReportRows,
  dedupeRows,
  memoizeDateFormatter,
} from './reportExportData';

/**
 * File report CSV transform. One row per download, deduplicated to match the
 * legacy CSV report. The shared work lives in reportExportData.
 */
const useExportData = ({ onProgress }: { onProgress?: (completed: number, total: number) => void } = {}) => {
  const { state: { queryVariables } } = useContext(Context);
  const client = useApolloClient();

  //works as callback function into export
  async function getData(recordData) {
    const formatDownloadDate = memoizeDateFormatter(
      (value) => dateFormater(String(value), 'LLLL dd, yyyy HH:mm', true),
    );

    const downloadsById = await fetchAllDownloads(client, recordData, queryVariables?.filterString, onProgress);
    const rows = await buildReportRows(recordData, downloadsById, formatDownloadDate);

    return [HEADERS, dedupeRows(rows)];
  }

  return {
    getData
  }
}

export default useExportData;
